import { clearAuthCookies, makeRequest, stopMasquerading } from "../util";
import { signOut } from "@/auth/firebase";
import { clearDarkModeFlagCache } from "@/theme/darkModeFlagCache";

export function signout() {
  stopMasquerading();
  clearDarkModeFlagCache();
  makeRequest("invalidate_token")
    .then(() => {
      void signOut();
      clearAuthCookies();
    })
    .catch((_error) => {
      void signOut();
      clearAuthCookies();
    });
}
